module.exports = __webpack_public_path__ + "img/Group 1504775915.2ec5b1db.svg";